import template from './atm_load_profile.html';
import controller from './atm_load_profile.controller';
import './atm_load_profile.scss';

let ATMLoadProfileComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default ATMLoadProfileComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/atm_load_profile.component.js